/* 🤖 this file was generated by svg-to-ts */
export const mgcIconBatteryFilled: {
  name: 'battery-filled';
  data: string;
} = {
  name: 'battery-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.58 6.047c-.733.14-1.4.821-1.537 1.57-.06.331-.06 8.435 0 8.766.141.768.806 1.433 1.574 1.574.333.06 13.433.06 13.766 0 .768-.141 1.433-.806 1.574-1.574.023-.131.043-.492.043-.803v-.566l.305-.047c.823-.128 1.505-.782 1.652-1.584.056-.311.056-2.455 0-2.766-.147-.802-.829-1.456-1.652-1.584L19 8.986V8.42c0-.311-.02-.672-.043-.803-.141-.768-.806-1.433-1.574-1.574-.307-.056-13.508-.052-13.803.004"/></svg>`
};
